import type { ResolveVerificationParams } from '@/utils/workflow';

import { useAppContext } from '@/providers/app-provider/context';
import { resolveVerificationRedirect } from '@/utils/workflow';

export type UseResolveVerificationProps = Pick<ResolveVerificationParams, 'url' | 'payload'>;

export const useResolveVerification = ({ payload, url }: UseResolveVerificationProps) => {
  const { state } = useAppContext();

  return () => {
    resolveVerificationRedirect({
      url,
      payload,
      viewType: state.viewType!,
    });
  };
};
